import React from 'react';
import styles from './styles.css';

const getHtmlString = (value) => (typeof value === 'string' ? value : '');

export default function TooManySelectionsPlaceholder({ title, description }) {
	const titleHtml = getHtmlString(title);

	return (
		<div className={`${styles.wrapper} uk-width-1-1 uk-container`}>
			<div className={`${styles.container} uk-margin-large-bottom uk-overflow-auto`}>
				<h2 dangerouslySetInnerHTML={{ __html: titleHtml }}></h2>
				<hr />
				{description.map((line, index) => (
					<p key={`InvalidSelection_${index}`} dangerouslySetInnerHTML={{ __html: getHtmlString(line) }}></p>
				))}
			</div>
		</div>
	);
}
